export default __webpack_public_path__ + "static/media/Intimation of Postal Ballot Notice.6f489896.pdf";